// 用于保存缓存数据
var datas = {};

function load(that, api, code, afterRequest) {
  return new Promise(function(resolve, reject) {
    //判斷緩存中是否數據
    var _code = "" + api + code;
    if (datas[_code] != undefined) {
      resolve(datas[_code]); //返回緩存的對象
    } else {
      let opts = [];
      datas[_code] = opts;
      resolve(opts);
      that.ccRequest
        .do(
          api,
          {
            code: code,
          },
          "GET"
        )
        .then((res) => {
          if (typeof afterRequest == "function") {
            opts.push(...(afterRequest(res) || []));
          } else {
            res.rows[0].children.forEach((child) => {
              // 如果存在扩展语言就汇入
              let lang = {};
              if (child.extraData) {
                lang = { ...child.extraData };
              }
              opts.push({
                val: child.val,
                title: child.title,
                ...lang,
              });
            });
          }
          //将数据塞入缓存
          constantCache.set(_code, opts);
        })
        .catch((err) => {});
    }
  });
}

export default {
  load,
};
